// src/components/admin/page-sections/SpacerSection.js
import React from 'react';
import '../../../styles/sections.css';

const SpacerSection = ({ content }) => {
  const {
    spacerHeight = '2rem',
    tabletSpacerHeight,
    mobileSpacerHeight,
    hideOnDesktop = false,
    hideOnTablet = false,
    hideOnMobile = false,
    customClasses = '',
    id = ''
  } = content || {};

  // Create responsive styles object
  const spacerStyle = {
    height: spacerHeight
  };

  // Build CSS for media queries
  const generateMediaQueries = () => {
    let css = '';
    
    if (tabletSpacerHeight) {
      css += `
        @media (max-width: 1024px) and (min-width: 768px) {
          #${id || 'spacer'} { height: ${tabletSpacerHeight} !important; }
        }
      `;
    }
    
    if (mobileSpacerHeight) {
      css += `
        @media (max-width: 767px) {
          #${id || 'spacer'} { height: ${mobileSpacerHeight} !important; }
        }
      `;
    }
    
    return css;
  };

  // Create responsive visibility classes
  const visibilityClasses = [
    hideOnDesktop ? 'lg:hidden' : '',
    hideOnTablet ? 'md:hidden lg:block' : '',
    hideOnMobile ? 'hidden md:block' : ''
  ].filter(Boolean).join(' ');

  return (
    <>
      {/* Add media query styles */}
      {(tabletSpacerHeight || mobileSpacerHeight) && (
        <style dangerouslySetInnerHTML={{ __html: generateMediaQueries() }} />
      )}
      
      {/* Spacer element */}
      <div 
        id={id || undefined}
        className={`spacer ${customClasses} ${visibilityClasses}`}
        style={spacerStyle}
        aria-hidden="true"
      ></div>
    </>
  );
};

export default SpacerSection;




// // src/components/sections/SpacerSection.js
// import React from 'react';

// const SpacerSection = ({ content }) => {
//   const { spacerHeight = '2rem' } = content;

//   return <div style={{ height: spacerHeight }}></div>;
// };

// export default SpacerSection;
